import React from 'react';
import './MobileDownloadSection.scss';

const MobileDownloadSection = (props) => {
  const googlePlayIconUrl = `${props?.fields?.GooglePlayIcon?.value?.src}`;
  const appStoreIconUrl = `${props?.fields?.AppStoreIcon?.value?.src}`;
  const sectionImageUrl = `${props?.fields?.SectionImage?.value?.src}`;

  const pushDataLayerEvent = (ctaText, brandName, variantName) => {
    dataLayer.push({
      event: 'tvs_connect_app_download',
      cta_text: ctaText,
      BrandName: brandName,
      VariantName: variantName,
    });
  };

  const headingText = props?.fields?.Heading?.value || '';
  const words = headingText.split(' ');
  const firstLine = words.slice(0, 2).join(' ');
  const secondLine = words.slice(2).join(' ');

  return (
    <div className="mobile-download-section">
      <div className="content-wrapper">
        <div className="text-content">
          <h2 className="download-text">
            <span className="first-line">{firstLine}</span>
            <span className="second-line">{secondLine}</span>
          </h2>
          <div className="download-buttons">
            <a
              href={props?.fields?.GooglePlayLink?.value?.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={googlePlayIconUrl}
                alt={props?.fields?.GooglePlayIcon?.value?.alt}
                loading="lazy"
                onClick={() => pushDataLayerEvent('Google Play', 'TVS iQube', 'SmartXonnect')}
              />
            </a>
            <a
              href={props?.fields?.AppStoreLink?.value?.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={appStoreIconUrl}
                alt={props?.fields?.AppStoreIcon?.value?.alt}
                loading="lazy"
                onClick={() => pushDataLayerEvent('Apple Store', 'TVS iQube', 'SmartXonnect')}
              />
            </a>
          </div>
        </div>
        <div className="mobile-image">
          <img src={sectionImageUrl} alt={props?.fields?.SectionImage?.value?.alt} loading="lazy" />
        </div>
      </div>
    </div>
  );
};

export default React.memo(MobileDownloadSection);
